import React, { useState, useEffect, useContext } from 'react';
import CandleStickChart from '../components/CandleStickChart';
import { Grid, Button, TextField, useMediaQuery, Box } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import { useTheme } from '@mui/material/styles';
import LineChart from '../components/LineChart';
import { useNavigate } from 'react-router';
import { Card, CardContent, Tab, Tabs } from '@mui/material';
import socket from '../components/socket'



const JoinRoom = () => {

  const navigate = useNavigate();
 
  const [fetchDataClicked, setFetchDataClicked] = useState(false);

  const [responseData, setResponseData] = useState(null);
  const [userData, setUserData] = useState({ labels: [], datasets: [{ label: '', data: [], backgroundColor: ["rgba(75,192,192,0.2)",], borderColor: "black", borderWidth: 2, }] });

  const [roomId, setRoomId] = useState("");
  const theme = useTheme();
  const [lineC, setLineC] = useState(false)
  const [candleC, setCandleC] = useState(false)
  const [activeTab, setActiveTab] = useState(0);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));


  const joinRoom = () => {
    if (roomId !== "") {
      console.log(roomId)
      socket.emit("join_room", { room: roomId });

      // navigate(`/graph_room/${roomId}`)
    }
  }



  const handleRoomIdChange = (event) => {
    setRoomId(event.target.value);
  };


  const lineChart = () => {
    setLineC(!lineC);
    setFetchDataClicked(true);
  }

  const candleStickChart = () => {
    setCandleC(!candleC);
    console.log("clicked candlestick chart")
  }

  return (
    <div style={{ background: theme.palette.background.default, height: '100vh' }}>
      <Navbar />
      <Grid container direction="row" style={{ height: '100%' }}>
        <Grid item xs={2} sm={2}>
          <Sidebar />
        </Grid>
        <Grid item xs={10} sm={10} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center' }}>
          <Box mt={0} mb={-3}>
            <Grid item style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '100%', position: 'sticky', top: 0 }}>
              <Button variant="contained" color="primary" onClick={joinRoom} style={{ color: theme.palette.text.primary, marginRight: '1rem', textTransform: 'none', padding: '6px 16px' }}>Join Room</Button>
              <TextField label="Room ID" value={roomId} onChange={handleRoomIdChange} margin="normal" InputProps={{ style: { color: theme.palette.text.secondary, width: "400px" } }} />
            </Grid>
          </Box>


          <Grid item style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 'calc(100% - 100px)' }}>
            <Card style={{ width: "100%", height: '90%' }}>
              <Tabs value={activeTab} onChange={(event, newValue) => setActiveTab(newValue)} variant="fullWidth">
                <Tab label="Line Chart" />
                <Tab label="Candlestick Chart" />
              </Tabs>
              <div style={{ overflow: 'auto', height: 'calc(100% - 48px)' }}> {/* adjust 48px depending on the actual height of your tabs */}
                <CardContent style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', width: '100%', height: '100%' }}>
                  {activeTab === 0 && (
                    <div>

                      {userData && <LineChart chartData={userData} roomId={roomId} />}
                    </div>
                  )}
                  {activeTab === 1 && (
                    <div>

                      {<CandleStickChart roomId={roomId} />}
                    </div>
                  )}
                </CardContent>
              </div>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default JoinRoom;
